export default __webpack_public_path__ + "static/media/bg3.a21d7b55.mp4";